import * as Yup from 'yup'
import { InvoiceType, InvoiceTypeWithVehicleSales } from '@cbgms/api'
import { useTranslation } from 'react-i18next'

export function isValidPatternLength(values: { PatternExtra: string; PatternNumbers: string; PatternYear: string }): boolean {
  return values.PatternExtra.length + values.PatternNumbers.length + values.PatternYear.length <= 9
}

export const yearValidation = Yup.number().min(1900).max(3000)

export const useCreateValidationSchema = () => {
  const { t } = useTranslation()
  const requiredMessage = t('global.required_field')
  const invalidNumberMessage = t('global.value_out_of_bounds')

  return Yup.object().shape({
    Year: yearValidation.required(requiredMessage),
    NextNumber: Yup.number().min(0).optional(),
    InvoiceType: Yup.mixed<InvoiceType | InvoiceTypeWithVehicleSales>()
      .oneOf([...Object.values(InvoiceType), ...Object.values(InvoiceTypeWithVehicleSales)])
      .required(requiredMessage),
    PatternYear: Yup.string().required(requiredMessage),
    PatternExtra: Yup.string().matches(/[0-9]/, invalidNumberMessage).optional(),
    PatternNumbers: Yup.string().required(requiredMessage)
  })
}
